export const tributeColumns = [
  {
    id: "donorName",
    displayName: "Donor name",
    headerName: "Donor name",
    field: "donorName",
    flex: 1,
  },
  {
    id: "tributeType",
    displayName: "Tribute type",
    headerName: "Tribute type",
    field: "tributeType",
    flex: 1,
  },
  {
    id: "recipientName",
    displayName: "Recipient name",
    headerName: "Recipient name",
    field: "recipientName",
    flex: 1,
  },

  {
    id: "date",
    displayName: "Date",
    headerName: "Date",
    field: "date",
    flex: 1,
  },
  {
    id: "cause",
    displayName: "Cause",
    headerName: "Cause",
    field: "cause",
    flex: 1,
  },
  {
    id: "amount",
    displayName: "Amount",
    headerName: "Amount",
    field: "amount",
    flex: 1,
  },
  {
    id: "sent",
    displayName: "Sent",
    headerName: "Sent",
    field: "sent",
    flex: 1,
  },
  {
    id: "tributeMessage",
    displayName: "Tribute message",
    headerName: "Tribute message",
    field: "tributeMessage",
    flex: 1,
  },
  {
    id: "paper",
    displayName: "Paper",
    headerName: "Paper",
    field: "paper",
    flex: 1,
  },
  {
    id:"donationRecipientName",
    displayName:"Donation Recipient Name",
    headerName:"Donation Recipient Name",
    field:"donationRecipientName",
    flex:1
  },
  {
    id: "email",
    displayName: "Email",
    headerName: "Email",
    field: "email",
    flex: 1,
  }
];